import { AreaBooking, ExchangeRate, Sundry, CreativeStudio } from './../generated/graphql';
import { CalculateAreaBookingPricing } from './../contexts/Daybook/DayBookContext';
import { createNumberMask } from "text-mask-addons/dist/textMaskAddons";
import { get } from "immutadot";
import { differenceInWeeks, parse, getDay, setDay, addWeeks } from 'date-fns';
import { calculateSummaries } from '../handlers/campaigns/panes/AreaBookingPane';
import { Campaign, Daybook, DaybookDocument } from '../generated/graphql';
import { useCallback, useRef } from "react";
import { ExchangeRatesContextValue } from '../contexts/exchange-rates-context';
import { isSpecialValue } from "./tree-walker";


export function uniqueId() {
  return 'new'+Math.floor(Math.random() + Date.now());
}


export function asMoneyWithDivisor({ value, divisor, places = 2, comma = false }) {
  // 1. Convert input to a safe number. If falsy or invalid, default to 0.
  let num = Number(value);
  if (isNaN(num) || !value) num = 0;

  // 2. Apply the mathematical divisor if it exists and is valid
  if (divisor && Number(divisor) !== 0) {
    num = num / Number(divisor);
  }

  // 3. Use Intl.NumberFormat to handle commas and decimal places perfectly
  return new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: places,
    maximumFractionDigits: places,
    useGrouping: comma // Automatically handles thousands separators (commas)
  }).format(num);
}


export function asMoney2(val,places=2,comma=false) {
  if(!val) return '0.'+('0'.repeat(places));
  let v = String(val);
  console.log('number is',v,'padding is',places);
  v = v.padStart(places+1,'0');

  let digits = v.substr(0,v.length-places);
  if(comma && digits.length>3) {
    digits = new Intl.NumberFormat('en-GB').format(parseInt(digits));
  }
  return digits+'.'+v.substr(v.length-places,places);
//  return +'.'+v.substr(v.length-places,places);
  //+'.'+v.substr(v.length-places,places);
}

export function asMoney(val) {
  if (!val) return '0.00';
  let v = String(val);
  if (v.length === 1) { v = '00' + v; }
  if (v.length === 2) { v = '0' + v; }
  return v.substr(0, v.length - 2) + '.' + v.substr(v.length - 2, 2);
}

const hookReturn = (func) => {
  const listener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      const expanded = event.target?.ariaExpanded;
      if(expanded=='true') return;
      event.preventDefault();
      event.stopPropagation();

      // some nonsense around search values - skipping for now!
//      var val = event.target.closest('.search-value');
      //if(!val) { val = event.target.closest('form'); }
      if(func) {
        func();
      }
    }
  };
  document.addEventListener("keydown", listener,true);
  return () => {
    document.removeEventListener("keydown", listener,true);
  };
};

const week0 = parse('2000-01-03', 'yyyy-MM-dd', new Date());

function getWeekNum(date) {
  //console.log('differenceInWeeks',{num:num,vw:this.viewWeek,w0:this.week0});
  return differenceInWeeks(date, week0);
  //    return this.viewWeek.diff(this.week0, 'week');
}

export function getWeekForNum(weekNum) {
  //console.log('differenceInWeeks',{num:num,vw:this.viewWeek,w0:this.week0});
  return addWeeks(week0,weekNum);
  //    return this.viewWeek.diff(this.week0, 'week');
}



function getObjectByPath(obj, path) {
  try {
    //var ret =  get(obj,path);
    //console.log(obj,path,ret);
    return get(obj, path);
  } catch (e) {
    console.error('GOBP', 'Path lookup failed', e, obj, path);
    return null;
  }
  /*    try {
          return path.split('.').reduce((o, i) => o[i], obj);
      } catch(e) {
          console.error('GOBP','Path lookup failed',e,obj,path);
          return null;
      }*/
}


function moneyToInt(val) {
  if (!val) return 0;
  const v = val.toString().split('.');
  let value = 0;
  if (v[0].length) {
    value += parseInt(v[0].replace(/,|£/g, '')) * 100;
  }
  if (v.length === 2) {
    if (v[1].length === 2) {
      value += parseInt(v[1]);
    }
    if (v[1].length === 1) {
      value += parseInt(v[1]) * 10;
    }
  }
  return value;
}

export function isoTimestampToUk(val) {
  if (!val) return '';
  const ts = val.split(' ');
  const p = ts[0].split('-');
  return p[2] + '/' + p[1] + '/' + p[0]+' '+ts[1];

}

const months = {
  '01':'Jan',
  '02':'Feb',
  '03':'Mar',
  '04':'Apr',
  '05':'May',
  '06':'Jun',
  '07':'Jul',
  '08':'Aug',
  '09':'Sep',
  '10':'Oct',
  '11':'Nov',
  '12':'Dec'
};

/** 
 * Converts YYYY-MM-DD to DD MMM YYYY
 */
export const isoDateToMMM = function (val) {
  if (!val) return '00 00 0000';
  const p = val.split('-');
  if(p[0]=='0000') return '00 00 0000';
  return p[2] + ' ' + months[p[1]] + ' ' + p[0];
}

export const isoDateToMMMWithTime = function (val,seconds=true) {
  if (!val) return '00 00 0000';
  const timeSplit = val.split(' ');
  const p = timeSplit[0].split('-');
  if(p[0]=='0000') return '00 00 0000';
  if(!seconds && timeSplit[1]?.length==8) {
    timeSplit[1] = timeSplit[1].substring(0,5);
  }
  return p[2] + ' ' + months[p[1]] + ' ' + p[0]+' '+timeSplit[1];
}


export function isoDateToUk(val) {
  if (!val) return '';
  const p = val.split('-');
  return p[2] + '/' + p[1] + '/' + p[0];
}

export function isoDateTimeToUk(val) {
  if (!val) return '';
  const dt = val.split(' ');
  const p = dt[0].split('-');
  return p[2] + '/' + p[1] + '/' + p[0]+' '+dt[1];
}

function ukDateToIso(val) {
  if (!val) return '';
  const p = val.split('/');
  return p[2] + '/' + p[1] + '/' + p[0];
}

export function currentWeek() {
  const today = new Date();
  return getDay(today) < 1 ? setDay(today, -5, { weekStartsOn: 1 }) : setDay(today, 1, { weekStartsOn: 1 })
}



const currencyMask = createNumberMask({ prefix: '£', allowDecimal: true });
const numberMask = createNumberMask({ prefix: '', allowDecimal: false, includeThousandsSeparator: false });

export { hookReturn, ukDateToIso, moneyToInt, currencyMask, numberMask, getObjectByPath, getWeekNum };

// for the dropdown select value
type SectionSummaryValue = {
  label:string,
  value:number|string
};

type SectionSummary = {
  name:string,
  amount?:number|SectionSummaryValue
};

type Section = {
  label:string,
  addsTo?:string|null,
  total?:number
}
type SectionHash = {
  [key:string]:Section
}

const sections:SectionHash = {
  sundries: {
    label: 'Sundry',
    addsTo: 'undiscountable'
  },
  ambients: {
    label:'Ambient',
    addsTo:'undiscountable'
  },
  experientials: {
    label:'Experiential',
    addsTo:'undiscountable'
  },
  photoPaidTotal: {
    label:'Pro Photography',
    addsTo:'undiscountable'
  },
  panelBookings: {
    label:'Panel Bookings',
    addsTo:'discountable'
  },
  areaBookings: {
    label:'Area Bookings',
    addsTo:'discountable'
  },
  digitalBookings: {
    label:'Digital Bookings',
    addsTo:'discountable'
  },
  digitalBookingsDirect: {
    label:'Digital Bookings Direct',
    addsTo:'undiscountable'
  },
  mediaProductions: {
    label:'Media Production',
    addsTo:'undiscountable'
  },
  creativeStudio: {
    label:'Creative Studio',
    addsTo:'undiscountable'
  },
  costs: {
    label:'Costs',
    addsTo:null
  }
};

type CalcCampaignTotalsArgs = {
  campaignValues:Campaign,
  options?:any,
  daybookConfig:Daybook,
  calculateAreaBookingPricing?:any,
  exchangeRates:ExchangeRatesContextValue
};

export function calcCampaignTotals({campaignValues,options=null,exchangeRates,daybookConfig,calculateAreaBookingPricing}:CalcCampaignTotalsArgs) {
  console.log('CCT',campaignValues,options,exchangeRates,daybookConfig,calculateAreaBookingPricing);
  const totals: any = {
    undiscountable: 0,
    discountable: 0
  };
  let discountLabel = '';
  let isCommission = false;
  if(campaignValues?.clientCompany?.clientType?.supports_commission &&
    campaignValues?.salesTeam?.supports_commission) {
      discountLabel = 'Commission';
      isCommission = true;
    } else {
      discountLabel = 'Discount';
      isCommission = false;
    }
console.log('DAYBOOK CONFIG IS',daybookConfig);
  let agency = 0; 
  let direct = 0;
  Object.entries(sections).forEach(([sectionKey,section]) => {
    console.log('CS1 calcTOTALS');
    const rows = campaignValues[sectionKey];
    let total = 0;
    let total_global = 0;
    console.log("sectionKey", sectionKey, "section", section)
    switch(sectionKey) {
      case 'areaBookings':
        if (rows) {
          (rows as AreaBooking[]).forEach((row) => {
            const summaries = calculateSummaries({data: row,calculateAreaBookingPricing,exchangeRatesContext:exchangeRates, values: campaignValues});
            console.log('summaries',summaries,row);
            total+= exchangeRates?.calcExchangeRate((row as any)?.campaignComponent?.currency,summaries.totalValue,1);
          });
          console.log('CS0','[CalcTotals]','areaBookings',total);
        }
      break;
      case 'sundries':
        if(rows) {
          (rows as Sundry[]).forEach((row) => {
            const ppu = (row?.campaignComponent?.unit_value_local??0) / (row?.campaignComponent?.price_divisor ? row?.campaignComponent?.price_divisor : 1);
            const t = exchangeRates?.calcExchangeRate(row?.campaignComponent?.currency, ppu, (row?.campaignComponent?.qty??0));
            if(row.use_global_discount) {
              total_global += t;
            } else {
              total += t;
            }
          });
        }
      break;
      case 'digitalBookings':
        if (rows) {
          rows.forEach((row) => {
              const costType = row?.cost_type; 
              const unitValue = row?.campaignComponent?.unit_value_local / (row?.campaignComponent?.price_divisor ? row?.campaignComponent?.price_divisor : 1);
              const totalValue = exchangeRates.calcExchangeRate(row.campaignComponent?.currency, unitValue, row?.campaignComponent?.qty);

              if (costType === 'agency') {
                agency += totalValue;
                console.log(`Adding to Discountable total  as agency: ${agency}`);
              } else {
                direct += totalValue;
              }
          });
      }
      break;
      case 'photoPaidTotal':
        if(rows) {
          total = typeof rows === 'number' ? rows : Number(rows ?? 0);
        }
      break;
      default:
        if (rows) {
          rows.forEach((row) => {
            total += exchangeRates.calcExchangeRate(row.campaignComponent?.currency,row?.campaignComponent?.unit_value_local/(row?.campaignComponent?.price_divisor ? row?.campaignComponent?.price_divisor : 1), row?.campaignComponent?.qty);
          });
        }
      break;
    }
    if(isNaN(total)) {
      console.log('SECTION total is',total,sectionKey);
    }
    if (section.label === 'Digital Bookings Direct') {
      section.total = direct;
    } else if (section.label === 'Digital Bookings') {
      section.total = agency;
    } else {
      section.total = total; // For all other sections
    }
    if(section.addsTo) {
      totals[section.addsTo] += section.total;
    }
    if(total_global) {
      sections[sectionKey+'Discountable'] = {
        label: section.label+' (discountable)',
        total: total_global
      };
      totals['discountable'] += total_global;
    }
  });
  const values:SectionSummary[] = [];
  const dp = campaignValues.discount_percentage;
  const discountAmount = Math.round(totals.discountable * ((dp??0) / 100));
  const discountedTotal = totals.discountable - (discountAmount + (campaignValues.discount_final??0));
  totals['discountedTotal'] = discountedTotal;
  totals['preVatTotal'] = totals.undiscountable + discountedTotal;
  if(sections.panelBookings.total) {
    values.push({name: 'Panels', amount: sections.panelBookings.total});
  }
  if(sections.areaBookings.total) {
    values.push({name: 'Area', amount: sections.areaBookings.total});
  }
  if(sections.sundriesDiscountable) {
    values.push({name: 'Other ('+discountLabel+'able)', amount: sections.sundriesDiscountable.total});
  }
  values.push({name: discountLabel+'able Total', amount: totals.discountable});
  if(sections.experientials.total) {
    values.push({name: 'Experiential', amount: sections.experientials.total});
  }
  if(sections.ambients.total) {
    values.push({name: 'Ambient', amount: sections.ambients.total});
  }
  if(sections.creativeStudio.total) {
    values.push({name: 'Creative Studio', amount: sections.creativeStudio.total});
  }
  if(sections.digitalBookings.total || sections.digitalBookingsDirect.total) {
    const combinedDigitalTotal = (sections.digitalBookings.total ?? 0) + (sections.digitalBookingsDirect.total ?? 0);
    values.push({ name: 'Digital Booking', amount: combinedDigitalTotal });
  }
  values.push({name: 'Other', amount: sections.sundries.total??0});
  values.push({name: 'Media Production', amount: sections.mediaProductions.total??0});
  values.push({name: 'Costs', amount: sections.costs?.total??0});
  values.push({name: 'Pro Photography', amount: sections.photoPaidTotal.total});
  values.push({name: 'Non Discountable Total', amount: totals.undiscountable});

  const valuesB:SectionSummary[] = [];
  valuesB.push({name: discountLabel+'able Total', amount: totals.discountable??0});
  valuesB.push({name: discountLabel, amount: {value:dp??0,label:(dp??0)+'%'}});
  valuesB.push({name: discountLabel+' Amount',amount:discountAmount??0});
  valuesB.push({ name: 'Discount (Good Will)' });
  valuesB.push({name: (isCommission?'Commission/':'')+'Discounted Total', amount: discountedTotal});
  valuesB.push({name: '+ Non Discountable Total', amount: totals.undiscountable});
  valuesB.push({name: '= Total Cost', amount: totals.undiscountable + discountedTotal});


  const hasTax = campaignValues.salesTeam?.has_tax;

  // tax is the salesTeam amount, unless zero in which case use server amount
  const taxAmount = campaignValues.salesTeam?.tax_amount?campaignValues.salesTeam?.tax_amount:(daybookConfig?.salesTaxAmount??0);

  const vat = Math.floor((totals.undiscountable + discountedTotal) * (
    hasTax?taxAmount/100:1)
    );
  if((!options || !options.isVatExempt) && campaignValues?.salesTeam?.has_tax)  {
    valuesB.push({name:'+ '+daybookConfig?.salesTaxLabel,amount: vat});
    valuesB.push({
      name: 'Total with '+daybookConfig?.salesTaxLabel+' ('+taxAmount+'%)',
      amount: totals.undiscountable + discountedTotal + vat
    });
  }
  return {values:values,valuesB:valuesB,finalTotal:totals.undiscountable + discountedTotal + vat,preVatTotal:totals.preVatTotal};
}

export function deepCopy<Type>(aObject:Type|null):Type|null {
  // Prevent undefined objects
  if(aObject===null) return null;
  /*** @ts-ignore  */
  const bObject:Type = Array.isArray(aObject) ? [] : {};

  let value;
  for (const key in aObject) {

    // Prevent self-references to parent object
    // if (Object.is(aObject[key], aObject)) continue;

    value = aObject[key];

    // File/Blob are immutable blobs - pass them through verbatim instead of
    // recursing into them (which would produce a partial {} copy)
    if (isSpecialValue(value)) {
        bObject[key as string|number] = value;
    } else {
        bObject[key as string|number] = (typeof value === "object") ? deepCopy(value) : value;
    }
  }

  return bObject;
}

export const calculateFixedRowValue = (values) => {
    if (!values || !values.length) return 0;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const getDaysBetween = (startDate, endDate) => {
        const start = new Date(startDate);
        let end = new Date(endDate);
        if (!endDate || endDate === '0000-00-00') {
            end = today;
        }
        const millisecondsPerDay = 1000 * 60 * 60 * 24;
        return Math.ceil((end.getTime() - start.getTime()) / millisecondsPerDay);
    };

    const totalAmount = values
        .filter(val => val.rentalType && val.rentalType.label === 'Rental')
        .reduce((acc, val) => {
            const days = getDaysBetween(val.start_date, val.expiry_date);
            const dailyRate = parseFloat((Number(val.amount) / 36500).toFixed(2));
            const proratedAmount = dailyRate * days;
            return acc + proratedAmount;
        }, 0);
        
        return totalAmount;

};
